import { loginWithRedirect } from "@newsenec/auth-provider";

export const WelcomeScreenControl = () => {
    void loginWithRedirect();
    return <></>;
};
